import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from '@configs/axios';

const operations = {
    createBuyOrder: createApiService(
        (pair_type, type, pair_price, pair_amount, request_type, irrWallet = false, usdtWallet = false) => {
            const data = { pair_type, type, pair_price, pair_amount, request_type, irr_wallet: irrWallet, usdt_wallet: usdtWallet };
            return axios.post('/exchange/buyRequest', data);
        },
        { ...API_CONFIGS.POST_ACTION, context: 'Order - Create Buy Order' }
    ),

    createSellOrder: createApiService(
        (pair_type, type, pair_price, pair_amount, request_type, receipt_type) => {
            const data = { pair_type, type, pair_price, pair_amount, request_type, receipt_type };
            return axios.post('/exchange/sellRequest', data);
        },
        { ...API_CONFIGS.POST_ACTION, context: 'Order - Create Sell Order' }
    ),
    fetchOrders: createApiService(
        (page = 1, query = '') => {
            const ordersQuery = `?page=${page}${query}`;
            return axios.get(`/orderList${ordersQuery}`);
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Order - Fetch Orders' }
    ),

    cancelOrder: createApiService(
        (orderId) => {
            const data = { order_id: orderId };
            return axios.post('/cancelOrder', data);
        },
        { ...API_CONFIGS.POST_ACTION, context: 'Order - Cancel Order' }
    ),
    orderCalculator: createApiService(
        (startDate, endDate, signal) => {
            const url = (startDate === "" || endDate === "" || startDate === undefined || endDate === undefined)
                ? `/order/calculator`
                : `/order/calculator?from_date=${startDate}&to_date=${endDate}`;
            return axios.get(url, { signal });
        },
        {
            ...API_CONFIGS.GET_WITH_DATA,
            context: 'Order - Calculator',
            onError: (error) => {
                // Handle aborted requests gracefully
                if (error.name === 'AbortError' || error.name === 'CanceledError' ||
                    (error.message && error.message.includes('canceled'))) {
                    // Silent handling of canceled requests - no logging needed
                    return { data: { list: [], average: null } };
                }
            }
        }
    )
}

export default operations
